import { ISdkModel, ITextBodyModel } from '../../store-manager';
import type { ImageBlobAndString } from '../image-prepare-plugin';
import { ICopyPasteInjectable, CopyPastePrivateTag } from '../../../inject/copy-paste-injectable.interface';


abstract class BasePrepareModel {
    protected privateTag: CopyPastePrivateTag;

    public constructor(private copyPasteInjectable: ICopyPasteInjectable) {
        this.privateTag = this.copyPasteInjectable?.isLocalEdit
            ? CopyPastePrivateTag.TcoLocalSlideData
            : CopyPastePrivateTag.TcoSlideData;
    }


    /**
     * 从 html 中读取私有数据
     * @param {string} htmlString
     * @returns {string | null | undefined}
     */
    public getPrivateData(htmlString: string): {
        privateData: string | null | undefined,
        privateTag: CopyPastePrivateTag
    } {
        // 复制数据源
        let privateData;
        let fromPrivateTag;
        if (htmlString.includes(CopyPastePrivateTag.TcoSlideData)) {
            fromPrivateTag = CopyPastePrivateTag.TcoSlideData;
        } else if (htmlString.includes(CopyPastePrivateTag.TcoLocalSlideData)) {
            fromPrivateTag = CopyPastePrivateTag.TcoLocalSlideData;
        }
        if (fromPrivateTag) {
            const htmlDocument = new DOMParser().parseFromString(htmlString, 'text/html');
            privateData = htmlDocument?.querySelector(`*[${fromPrivateTag}]`)?.getAttribute(fromPrivateTag);
        }
        return {
            privateData,
            privateTag: fromPrivateTag,
        };
    }

    /**
     * 开启base64后，htmlData是promise
     * @param promiseHtmlData promise的html数据
     * @param imageBlobAndString 使用截图工具生成的图片数据
     * @returns
     */
    public asyncGetHtml(promiseHtmlData: Promise<ISdkModel>, imageBlobAndString?: ImageBlobAndString): Promise<string> {
        return Promise.resolve(promiseHtmlData).then(htmlData => this.getHtml?.(htmlData, imageBlobAndString));
    }

    /**
     * 将私有数据插入到 html 中
     * @param {Element} elementTag 目标元素
     * @param {BaseComponent} sdkData 私有数据
     * @returns {string}
     */
    protected insertPrivateData(elementTag: Element, sdkData: ISdkModel | ITextBodyModel): string | undefined {
        // 这里将sdkData NaN和INF转换成了null，添加对NaN和INF的处理，复制时将NaN与INF转换成字符串保留
        try {
            const tcoData = JSON.stringify(sdkData, (key, value) => {
                if (typeof value === 'number' && (isNaN(value) || !isFinite(value))) {
                    return value.toString();
                }
                return value;
            });
            elementTag.setAttribute(this.privateTag, tcoData);
            return tcoData;
        } catch (e) {
            window.log.error('[ClipboardManager] insertPrivateData error', e);
        }
    }

    protected getFirstSelectedElement(selectedSdkDataArray: { data: any[]; }): any {
        return selectedSdkDataArray?.data?.[0];
    }

    protected containerTagIsImage(privateData: ISdkModel | ITextBodyModel, imgStr: string | undefined): string {
        const containerTag = document.createElement('Img');
        containerTag.setAttribute('src', imgStr || '');
        this.insertPrivateData(containerTag, privateData);
        return containerTag.outerHTML;
    }

    public abstract getHtml (htmlData: ISdkModel, imageBlobAndString?: ImageBlobAndString): string;
}

export default BasePrepareModel;
